export enum Role {
    staff = 'staff',
    personal = 'personal',
    business = 'business',
    agent = 'agent',
    enterprise = 'enterprise',
    enterprise_staff = 'enterprise_staff',
    enterprise_contact = 'enterprise_contact',
}
